export default {
  header: "Contact",
  view: "contact"
};
